import {Injectable} from '@angular/core';
import {BaseRestService} from './base-rest.service';
import {AppSettingsService} from './app-settings.service';
import {HttpClient} from '@angular/common/http';
import { SendBackResult} from '..';
import {Observable} from 'rxjs';
import {SubscriptionClose} from '../models/subscription-i';

@Injectable({
  providedIn: 'root'
})
export class CloseSubscriptionService extends BaseRestService {
  constructor(http: HttpClient, appSettingsService: AppSettingsService) { super(http, appSettingsService); }

  protected get className(): string { return 'CloseSubscriptionService'; }

  protected get isAnonymous(): boolean { return false; }

  endBilling(companyUuid: string , contractUuid: string , form: SubscriptionClose[], comment: string): Observable<SendBackResult<boolean>> {
    return this.put<boolean>(`/Company/${companyUuid}/Contract/${contractUuid}/EndBilling`, {subscriptions: form, comment: comment});
  }
  // tslint:disable-next-line:no-any
  endBillingComplex(form: any): Observable<SendBackResult<boolean>> {
    return this.put<boolean>(`/Company/BillingDates`,  form);
  }

}
